import React, { Component } from 'react';
import { reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import submit from './submit';
import validate from './validate';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatLocaleData } from '../../../../helpers/formatLocale';

import cs from '../../../../components/commonStyle.css';
import s from './WhyHostFormBlock6.css';
import messages from '../../../../locale/jsonMessages';
class WhyHostFormBlock6 extends Component {

    render() {

        const { error, handleSubmit, submitting, selectedLanguage } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
                <h1 className='siteAdminHeading'><FormattedMessage {...messages.whyBecomeOwnerBlock7} /></h1>
                <form onSubmit={handleSubmit(submit)}>
                    {error && <strong>{formatMessage(error)}</strong>}
                    <div className="oneColumnGrid">
                        <FieldArray
                            name="dynamicWhyHostInfoBlock"
                            component={FieldArrayComponent}
                            selectedLanguage={selectedLanguage}
                            activesFields={['peaceTitleHeading', 'peaceTitle3', 'peaceContent3', 'language']}
                            filedName="dynamicWhyHostInfoBlock"
                        />
                    </div>

                    <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
                        <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
                            <FormattedMessage {...messages.save} />
                        </Button>
                    </div>
                </form>
            </div>
        );
    }

}

WhyHostFormBlock6 = reduxForm({
    form: 'WhyHostForm',
    validate
})(WhyHostFormBlock6);

const selector = formValueSelector('WhyHostForm');

const mapState = state => ({
    selectedLanguage: selector(state, 'dynamicWhyHostInfoBlock'),
    activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default injectIntl(withStyles(cs, s)(connect(mapState, null)(WhyHostFormBlock6)));


